
import { reactive, computed, defineComponent, onMounted } from 'vue'
import bus from './bus'
export default defineComponent({
  name: 'ContextMenuItem',
  props: {
    disabled: Boolean,
    divider: {
      type: Boolean,
      default: false
    }
  },
  setup (props, { emit }) {
    const val = reactive({ value: {} })
    function handleClick () {
      emit('itemClickHandle', val.value)
      bus.emit('item-click')
    }

    onMounted(() => {
      bus.on('bindValue', e => {
        val.value = e
      })
    })

    const itemClass = reactive({
      'v-contextmenu-item--disabled': computed(() => props.disabled)
    })

    return { itemClass, handleClick }
  }
})
